<svg
  id="svg"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  width="400"
  height="400"
  viewBox="0, 0, 400,400"
>
  <g id="svgg">
    <path
      id="path0"
      d="M114.876 113.477 C 101.827 175.889,90.992 227.744,90.797 228.711 L 90.443 230.469 119.831 230.469 C 142.821 230.469,149.218 230.681,149.217 231.445 C 149.216 231.982,145.899 270.033,141.846 316.001 C 137.793 361.970,134.629 399.734,134.816 399.921 C 135.302 400.407,128.447 411.016,222.600 264.063 L 309.446 128.516 265.451 128.125 L 221.456 127.734 241.176 64.063 C 252.023 29.043,260.906 0.303,260.917 0.195 C 260.928 0.088,233.412 0.000,199.769 0.000 L 138.601 0.000 114.876 113.477 "
      fill-rule="evenodd"
    ></path>
  </g>
</svg>
<!-- TODO: replace icon with correct one from Ivan -->
